import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Alert } from "@mui/material";
import { SEOForm } from "components";
import {
  getMetaDetailsByPathname,
  createMetaDetails,
  updateMetaDetails,
} from "actions";
import { clearError, clearMetaDetails } from "features/metaDetailsSlice";
import { META_DETAILS_PATHNAMES } from "constants/general";
import { ADMIN_TEXTS } from "constants/adminTexts";

const metaDetailsPathname = META_DETAILS_PATHNAMES.home;
const imageBase = process.env.REACT_APP_API_IMAGE_URL;

export const HomeMetaDetails = () => {
  const dispatch = useDispatch();
  const { metaDetails, loading, updateLoading, error } = useSelector(
    (state) => state.metaDetails,
  );

  const getInitialValues = () => {
    if (!metaDetails) return {};
    return {
      ...metaDetails,
      ogImage: metaDetails.ogImage
        ? `${imageBase}${metaDetails.ogImage.path}`
        : "",
    };
  };

  const handleSubmit = (values) => {
    const formData = new FormData();

    const { ogImage, ...rest } = values;
    for (const [field, value] of Object.entries(rest)) {
      formData.append(field, value);
    }

    if (ogImage instanceof File) {
      formData.append("ogImage", ogImage);
    }

    if (!metaDetails) {
      formData.append("pagePathname", metaDetailsPathname);
      dispatch(createMetaDetails(formData));
    } else {
      dispatch(
        updateMetaDetails({ pathname: metaDetailsPathname, data: formData }),
      );
    }
  };

  useEffect(() => {
    dispatch(getMetaDetailsByPathname(metaDetailsPathname));
    return () => {
      dispatch(clearError());
      dispatch(clearMetaDetails());
    };
  }, [dispatch]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" fontWeight="bold" mb={3}>
        {ADMIN_TEXTS.home.metaDetailsTitle}
      </Typography>
      {error && (
        <Alert
          severity="error"
          sx={{ mb: 2 }}
          onClose={() => dispatch(clearError())}
        >
          {typeof error === "string" ? error : "Something went wrong"}
        </Alert>
      )}
      <SEOForm
        onSubmit={handleSubmit}
        initialValues={getInitialValues()}
        loading={loading || updateLoading}
      />
    </Box>
  );
};
